import React from "react";
import LazyLoad from "react-lazyload";
import Slider from "react-slick";
import axios from "axios";
import constant from "../../constant";
import Streetview from "../../components/Streetview";
import FavAction from "../../components/FavoritesComp/FavAction";
import { LoadingComp } from "../../components/LoadingComp";
import SingleMap from "../../components/MapComp/SingleMap";
import BookboxComp from "../../components/BookboxComp";
import WorkspaceComp from "../../components/WorkspaceComp";
import PopupComp from "../../components/PopupComp";
// import SignupPopup from "../../components/PopupComp/SignupPopup";
import Credentials from "../Credentials";

import { connect } from "react-redux";
import { getSigleCurrency } from "../../store/actions/singleCurrencyActions";
import "./style.scss";

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: "",
      isLogin: false,
      space: [],
      en_id: "",
      isLoading: true,
      isStreetView: false,
      isBooking: false,
      week: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    };
  }
  componentDidMount() {
    let O_Auth = JSON.parse(localStorage.getItem("O_Auth"));
    this.props.getSigleCurrency(O_Auth ? O_Auth.currency : 1);

    let _this = this;
    let url_split = this.props.location.pathname.split(".");
    let en_id = url_split[url_split.length - 2];

    // alert(en_id);

    axios
      .get(`${constant.phpHost}action/newspace.php`, {
        params: {
          todo: "get_single_space",
          en_id: en_id
        }
      })
      .then(function(res) {
        console.log(res);
        _this.setState({
          en_id,
          space: res.data,
          isLoading: false,
          user_id: O_Auth ? O_Auth.id : ""
        });
      });
  }

  handleToggle = () => {
    if (this.state.user_id === "") {
      this.setState({
        isLogin: true
      });
    } else {
      this.setState({
        isBooking: !this.state.isBooking
      });
    }
  };

  handleLogin = () => {
    this.setState({
      isLogin: !this.state.isLogin
    });
  };

  handleStreetViewClick = () => {
    this.setState({
      isStreetView: !this.state.isStreetView
    });
  };

  priceCalculation = price => {
    let cur_code = this.props.singleCurrency.code;
    let cur_value = this.props.singleCurrency.value;
    return this.codeOnly(cur_code) + " " + this.priceOnly(price, cur_value);
  };

  priceOnly = (price, cur_value) => {
    return (price /= cur_value).toFixed(2);
  };

  codeOnly = cur_code => {
    if (cur_code === "INR") {
      cur_code = "₹";
    }

    if (cur_code === "EUR") {
      cur_code = "€";
    }

    return cur_code;
  };

  render() {
    const { isLoading, isStreetView, space, week, en_id, user_id } = this.state;

    var settings = {
      customPaging: function(i) {
        return <img src={space.images[i]} alt="" />;
      },
      dots: true,
      dotsClass: "slick-dots slick-thumb",
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      initOnLoad: true,
      nextSlidesToPreload: 1,
      fade: true
    };

    if (isLoading) {
      return <LoadingComp customStyle={{ padding: "250px 0" }} />;
    } else if (this.state.isLogin) {
      return <Credentials isPopup={this.handleLogin} />;
    } else {
      return (
        <div className="view-page">
          {/* <SignupPopup /> */}
          <div className="content">
            <div className="left">
              <FavAction space_id={space.id} />
              <Slider {...settings}>
                {space.images.map((image, i) => (
                  <img key={i} src={image} alt="" />
                ))}
              </Slider>

              <div className="box">
                {space.amenities ? (
                  <div className="amenities">
                    <h3>Amenities</h3>
                    <ul>
                      {space.amenities.map((amenity, i) => (
                        <li key={i}>
                          <span>{space.view_amenities[amenity]}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
              </div>

              <div className="cols-6">
                <div className="box posted_by">
                  <h3>Posted by</h3>
                  <img className="dp" src={space.user.dp} alt="" />
                  <p>
                    <b>{space.user.name}</b>
                  </p>
                  <p className="company">{space.user.company}</p>
                </div>

                <div className="box open_hours">
                  <h3>Open Hours</h3>
                  {space.isFullHours > 0 ? (
                    <p>24/7</p>
                  ) : (
                    <ul>
                      {space.view_open_hours.map((hours, i) => (
                        <li key={i}>
                          <b>{week[hours.d_day]}</b>
                          <i>:</i>
                          <p>
                            {hours.d_start} <span>-</span> {hours.d_end}
                          </p>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="right">
              <div className="box">
                {isStreetView ? (
                  <Streetview
                    location={space.location}
                    handleStreetViewClick={this.handleStreetViewClick}
                  />
                ) : null}
                <h1>{space.title}</h1>
                <p className="location">
                  <i>Located near {space.location.place}</i>
                </p>

                <div className="price_box">
                  <div className="price">
                    <img src="/assets/images/svg/price.svg" alt="" />
                    <div>
                      <p>Price</p>
                      <p className="amount">
                        <span>
                          <b>{this.priceCalculation(space.price)}</b>
                          {space.isLongTerms === 1 ? (
                            <i> /{space.long_term}</i>
                          ) : (
                            <i> /{space.space.type === 1 ? "day" : "hour"}</i>
                          )}
                        </span>
                      </p>
                    </div>
                  </div>

                  {space.discount ? (
                    <div className="discount">
                      <img src="/assets/images/svg/discount_view.svg" alt="" />
                      <div>
                        <p>Discount</p>
                        <p className="d_amount">
                          {Object.keys(space.discount).map((price, i) => (
                            <span key={i}>
                              <b>
                                {this.priceCalculation(space.discount[price])}
                              </b>
                              <i> /{price}</i>
                            </span>
                          ))}
                        </p>
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="cols-6">
                  <div className="space">
                    <img src="/assets/images/svg/purpose.svg" alt="" />
                    <div>
                      <p>Purpose</p>
                      <p>
                        <b>
                          {space.space.type === 1
                            ? "Desk"
                            : space.space.type === 2
                            ? "Meeting Room"
                            : space.space.type === 4
                            ? "Cafe"
                            : ""}
                        </b>
                      </p>
                    </div>
                  </div>
                  <div className="space">
                    <img src="/assets/images/svg/desk.svg" alt="" />
                    <div>
                      <p>Available workspace</p>
                      <p>
                        <b>
                          upto {space.space.quantity} {space.space.q_name}
                        </b>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="space">
                  <img src="/assets/images/svg/location.svg" alt="" />
                  <div className="address">
                    <p>Address</p>
                    <p>
                      <b>
                        {space.location.address}, {space.location.place}
                      </b>
                    </p>
                  </div>
                  <span
                    className="street_view"
                    onClick={this.handleStreetViewClick}
                  >
                    View Street
                  </span>
                </div>
              </div>

              <div className="map">
                <SingleMap
                  listing={space}
                  priceCalculation={this.priceCalculation}
                />
              </div>
            </div>
          </div>
          <div className="booking">
            <p className="price">
              <span>
                <b>{this.priceCalculation(space.price)}</b>
                {space.isLongTerms === 1 ? (
                  <i> /{space.long_term}</i>
                ) : (
                  <i> /{space.space.type === 1 ? "day" : "hour"}</i>
                )}
              </span>
            </p>

            {user_id === space.user.id ? (
              <button className="bg-grey">Your Listing</button>
            ) : (
              <button onClick={this.handleToggle}>Book Now</button>
            )}
          </div>
          {this.state.isBooking ? (
            <PopupComp isPopup={this.handleToggle} width="35%">
              <div className="form-group">
                <h2>Finding workspace is available! </h2>
              </div>
              <BookboxComp
                en_id={en_id}
                parentProps={this.props}
                space={space}
              />
            </PopupComp>
          ) : null}
          <LazyLoad offset={50}>
            <WorkspaceComp
              title="Other Spaces you might like near"
              text="When you need to get united in the city, Heydesk's got the right space for you"
              location={space.location.place}
              city_id={space.location.city_id}
              country_id={space.location.country_id}
            />
          </LazyLoad>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    singleCurrency: state.singleCurrency.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSigleCurrency: id => dispatch(getSigleCurrency(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
